import React, { useEffect, useState } from 'react';
import { ModalAppearanceProps } from './types';
import { MODAL_APPEARANCE_TIME } from '@shared/config/style/modal';
import { getLastModal } from './get-last-modal';

export const ModalAppearance: React.FC<ModalAppearanceProps> = ({ isShow, children }) => {
    const [isShowModal, setIsShowModal] = useState(isShow);

    useEffect(() => {
        if (isShow && !isShowModal) {
            setIsShowModal(true);
            setTimeout(() => {
                setTimeout(() => {
                    getLastModal()?.setAttribute('style', `opacity: 1;`);
                }, 50);
            }, 0);
            return;
        }
        if (!isShow && isShowModal) {
            setTimeout(() => {
                getLastModal()?.setAttribute('style', '');
                setTimeout(() => {
                    setIsShowModal(false);
                }, MODAL_APPEARANCE_TIME);
            }, 0);
        }
    }, [isShow]);

    return <>{isShowModal && children}</>;
};
